import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { StaticTextHeadingFieldModel } from '../../../models/static-text-heading-field.model';
import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { ButtonTypesEnum } from '../../../../Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { FullProfileAnimationModel } from '../../../../../Core/Dialogs/models/full-profile-animation.model';
import { FullProfileDialogAnimationsEnum } from '../../../../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { OverlayAnimationStateEnum } from '../../../../../Core/Dialogs/enums/overlay-animation.enum';

@Component({
    selector: 'agpr-static-text-heading-field',
    templateUrl: './static-text-heading-field.component.html',
    styleUrls: ['./static-text-heading-field.component.scss'],
    standalone: false
})
export class StaticTextHeadingFieldComponent extends AbstractFormFieldComponent implements OnChanges {
    @Input() declare field: StaticTextHeadingFieldModel;

    showHeading: boolean = true;

    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        private coreDialogService: CoreDialogService
    ) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.field.appearCondition) {
            this.showHeading = this.field.appearCondition(this.block.displayElement);
        }
    }

    openActionPanel(): void {
        if (!this.field.action) {
            return;
        }
        const overlayContainer = document.getElementById('main-content');
        const animationTrigger = new BehaviorSubject(
            new FullProfileAnimationModel(FullProfileDialogAnimationsEnum.slideInOutAnimation, OverlayAnimationStateEnum.open)
        );
        this.coreDialogService.open(this.field.action.panel, { inputs: { animationTrigger, overlayContainer } });
    }
}
